'use client';

import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { Carousel } from '@/components/ui/Carousel';
import { useSafeRouter } from '@/hooks/route/useSafeRouter';
import BannerImage from './BannerImage';
import { useActiveBanners } from '@/hooks/banner/useActiveBanners';
import { useRef } from 'react';
import { createBannerAutoplayPlugin } from '../utils/bannerCarouselConfig';

const SliderDot = ({ isSelected, onClick }: { isSelected: boolean; onClick: () => void }) => {
  return (
    <Box
      as="button"
      onClick={onClick}
      width="8px"
      height="8px"
      borderRadius="4px"
      backgroundColor={isSelected ? 'common.100' : 'neutral.70'}
      margin={0}
      transition="background-color 0.3s"
      cursor="pointer"
      border="none"
      padding={0}
    />
  );
};

const BannerList = () => {
  const isMobile = useBreakpointValue({ base: true, tablet: false }) ?? false;
  const { push } = useSafeRouter();
  const activeBanners = useActiveBanners();

  const autoplayPlugin = useRef(createBannerAutoplayPlugin());

  if (activeBanners.length === 0) {
    return null;
  }

  return (
    <Carousel
      opts={{
        loop: true,
        align: 'center',
      }}
      plugins={[autoplayPlugin.current]}
    >
      <Carousel.Content style={{ height: '100%' }}>
        {activeBanners.map((banner, index) => (
          <Carousel.Item key={banner.bannerId} style={{ paddingLeft: '0', height: '100%' }} cursor="pointer">
            <BannerImage
              onClick={() => push(banner.linkUrl)}
              src={isMobile ? banner.mobileImageUrl : banner.imageUrl}
              alt={banner.title}
              priority={index === 0}
            />
          </Carousel.Item>
        ))}
      </Carousel.Content>

      <Flex position="absolute" bottom={4} left="50%" transform="translateX(-50%)" zIndex={1}>
        <Carousel.Dots gap={1.5} renderDot={(props) => <SliderDot {...props} />} />
      </Flex>
    </Carousel>
  );
};

export default BannerList;
